import { axios } from '@/utils/request'

const api = {
  Pre: '/index.php/Material/pre',
  List: '/index.php/Material/getList',
  DetailList: '/index.php/Material/getDetailList',
  Detail: '/index.php/Material/detail',
  UpdateMaterial: '/index.php/Material/updateMaterial',
  AddMaterial: '/index.php/Material/addMaterial',
  DeleteMaterial: '/index.php/Material/deleteMaterial',
  DeleteMaterialBatch: '/index.php/Material/deleteMaterialBatch',
  SaveMaterialDetail: '/index.php/Material/saveMaterialDetail',
  DeleteMaterialDetail: '/index.php/Material/deleteMaterialDetail',
  DeleteMaterialDetailBatch: '/index.php/Material/deleteMaterialDetailBatch',
}

// 预加载
export function getPre () {
  return axios({
    url: api.Pre,
    method: 'get'
  })
}

export function getList (parameter) {
  return axios({
    url: api.List,
    method: 'get',
    params: parameter
  })
}

export function getDetail (parameter) {
  return axios({
    url: api.Detail,
    method: 'get',
    params: {
      mat_id: parameter
    }
  })
}

export function postUpdateMaterial (parameter) {
  return axios({
    url: api.UpdateMaterial,
    method: 'post',
    data: parameter
  })
}

export function postAddMaterial (parameter) {
  return axios({
    url: api.AddMaterial,
    method: 'post',
    data: parameter
  })
}

export function deleteMaterial (parameter) {
  return axios({
    url: api.DeleteMaterial,
    method: 'post',
    data: parameter
  })
}

export function deleteMaterialBatch (parameter) {
  return axios({
    url: api.DeleteMaterialBatch,
    method: 'post',
    data: parameter
  })
}

export function getDetailList (parameter) {
  return axios({
    url: api.DetailList,
    method: 'get',
    params: parameter
  })
}

export function postSaveMaterialDetail (parameter) {
  return axios({
    url: api.SaveMaterialDetail,
    method: 'post',
    data: parameter
  })
}

export function deleteMaterialDetail (parameter) {
  return axios({
    url: api.DeleteMaterialDetail,
    method: 'post',
    data: parameter
  })
}

export function deleteMaterialDetailBatch (parameter) {
  return axios({
    url: api.DeleteMaterialDetailBatch,
    method: 'post',
    data: parameter
  })
}